import { InvoiceResumeDriverDetails } from '@allocab/allocab-driver-shared-types';

import { t } from '../../services/translation/translation';
import { formatPrice } from '../../utils/price';

type Props = {
  driverDetails: InvoiceResumeDriverDetails;
};

export const DriverAmountCalc = ({ driverDetails }: Props) => {
  if (
    Math.abs(
      driverDetails.brutBenefits -
        driverDetails.onBoardBrutBenefits -
        driverDetails.totalComOut -
        driverDetails.benefits,
    ) > 1
  ) {
    return (
      <p>
        <span>{t('invoicing-route.wrong-calc')}</span>
        {' = '}
        <span className="text-green-400 font-bold">{formatPrice(driverDetails.benefits)}</span>
      </p>
    );
  }

  return (
    <p>
      <span className="text-pink-400 font-bold">{formatPrice(driverDetails.brutBenefits)}</span>
      {' - '}
      <span className="text-blue-400 font-bold">{formatPrice(driverDetails.onBoardBrutBenefits)}</span>
      {' - '}
      <span className="text-orange-400 font-bold">{formatPrice(driverDetails.totalComOut)}</span>
      {' = '}
      <span className="text-green-400 font-bold">{formatPrice(driverDetails.benefits)}</span>
    </p>
  );
};
